export default "__VITE_ASSET__cec9fb7c__"